import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

// Use API base from environment or fallback
const BASE_URL = process.env.REACT_APP_API_URL ;

// Get Authorization headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
  };
};

// CREATE Legal Document
export const createLegalDoc = createAsyncThunk(
  'legalDocs/create',
  async ({superAdminId, documentType, name, file }, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("superAdminId",superAdminId)
      formData.append('documentType', documentType);
      formData.append('name', name);
      formData.append('file', file);

      const response = await fetch(`${BASE_URL}/add-legalDocument`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: formData,
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (err) {
        console.error('❌ Invalid JSON:', text);
        throw new Error('Invalid response format');
      }

      if (!response.ok) throw new Error(data.message || 'Upload failed');

      toast.success('✅ Document uploaded successfully');
      return data.document || data;
    } catch (error) {
      toast.error('❌ Upload failed: ' + error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// FETCH All Legal Documents
export const fetchLegalDocs = createAsyncThunk(
  'legalDocs/fetchAll',
  async (_, thunkAPI) => {
    try {
      const superAdminId=localStorage.getItem("adminuserId")||undefined;
      const res = await fetch(`${BASE_URL}/all-legalDocument?superAdminId=${superAdminId}`, {
        headers: getAuthHeaders(),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Fetch failed');
      return Array.isArray(data.documents) ? data.documents : [];
    } catch (error) {
      toast.error(error.message || 'Failed to fetch');
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// DELETE Legal Document
export const deleteLegalDoc = createAsyncThunk(
  'legalDocs/delete',
  async (id, thunkAPI) => {
    try {
      const res = await fetch(`${BASE_URL}/delete-legal-doc/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Delete failed');
      toast.success('🗑️ Document deleted');
      return id;
    } catch (error) {
      toast.error(error.message || 'Delete failed');
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Slice
const legalDocsSlice = createSlice({
  name: 'legalDocs',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createLegalDoc.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLegalDoc.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.id) state.list.push(action.payload);
      })
      .addCase(createLegalDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLegalDocs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLegalDocs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchLegalDocs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteLegalDoc.fulfilled, (state, action) => {
        state.list = state.list.filter((doc) => doc.id !== action.payload);
      });
  },
});

export default legalDocsSlice.reducer;
